import styled, { injectGlobal } from 'styled-components'
import { normalize } from 'polished'

export const font = {
  primary: `Helvetica, sans-serif`,
  system: `-apple-system, BlinkMacSystemFont,
    "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans",
    "Droid Sans", "Helvetica Neue", sans-serif`
}

export const color = {
  primary: 'rgb(27, 41, 32)',
  primaryLight: '#e2f7e2',
  secondary: '#212121',
  lightGrey: 'whitesmoke',
  midGrey: '#e4e4e4',
  darkGrey: '#999999',
  border: 'rgba(0,0,0,0.1)',
  black: '#212121',
  danger: '#ff3d3d',
  warning: '#ffdd57'
}

export const borderRadius = '4px'
export const borderRadiusSmall = '2px'

export const boxShadow =
  '0 2px 6px 0 rgba(0,0,0,0.04), 0 1px 2px 0 rgba(0,0,0,0.04), 0 1px 2px 0 rgba(0,0,0,0.18)'

export const boxShadowActive =
  '0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08)'

export const ease = {
  popIn: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)'
}

export const bp = {
  // media query breakpoints
  desktop: 'min-width: 650px'
}

export const mixin = {
  card: `
    box-shadow: ${boxShadow};
    border-radius: ${borderRadiusSmall};
    margin: 2rem;
    padding: 1.5rem;
    position: relative;
    overflow: hidden;
    text-decoration: none;
    will-change: transform, box-shadow, opacity;
    transition: all 0.35s ${ease.popIn};
  `,
  cardHover: `
    &:hover, &:focus {
      transform: translateY(-1px);
      opacity: 0.95;
      box-shadow: ${boxShadowActive};
    }
  `,
  transitionScale: `
    will-change: transform;
    transition: transform 0.5s ${ease.popIn};
    transform: translate3d(0,0,0);

    &:hover, &:focus {
      transform: scale(1.1);
    }
  `
}

export const AppWrap = styled.div`
  margin: 0;
  min-height: 100%;
  width: 100%;
  padding-bottom: 6.4rem;
  position: relative;
  background: ${color.lightGrey};

  @media (${bp.desktop}) {
    background: white;
    padding-bottom: 0;
  }
`

export default () => injectGlobal`
  ${normalize()}

  html {
    box-sizing: border-box;
    font-size: 62.5%;
    background: ${color.lightGrey};
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${font.system};
    min-height: 100%;
    width: 100%;
    position: relative;
    background: ${color.lightGrey};
    color: ${color.secondary};
    font-size: 1.6em;
    font-weight: 300;
    letter-spacing: .01em;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
  }

  #root {
    width: 100%;
    min-height: 100%;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  a {
    color: ${color.primary};
  }

  strong {
    font-weight: 600;
  }

  p {
    margin-top: 0;
    margin-bottom: 1em;
  }

  h1, h2, h3, h4, h5 ,h6{
    margin: 0;
    margin-bottom: 1em;
  }

  h1 {
    font-size: 3rem;
    font-weight: 700;
  }

  h2 {
    font-size: 2.8rem;
    font-weight: 700;
    margin-bottom: 2rem;
  }

  h3 {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
  }

  h4 {
    font-size: 1.7rem;
    font-weight: 600;
    margin-bottom: 2rem;
    line-height: 1.2;
  }

  h5 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 2rem;
  }

  h6 {
    text-transform: uppercase;
    font-weight: 700;
  }

  @media (min-width: 777px) {
    h1 {
      font-size: 4rem;
    }

    h2 {
      font-size: 3rem;
    }
  }

  input, textarea, select {
    font-size: inherit;
  }
`



// WEBPACK FOOTER //
// ./src/globalStyles.js